var App = App || {};

App.CookieNotice = (function ($) {
    'use strict';

    function Init() {

        const notice = $("#CookieNotice");
        const confirm = notice.find("[data-cookienotice='confirm']");

        if (notice) {
            confirm.on("click", function () {
                App.Cookies.setItem("atomiccu_CookieNotice", "confirmed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                notice.slideUp(250);
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);
